import Guide from './Guide';

export enum ConditionAssociation {
  POSITIVE = 'positive',
  NEGATIVE = 'negative',
}
export enum ConditionType {
  BIOMARKER = 'biomarker',
  ASSOCIATION = 'association',
}
export enum ConditionEvaluationMeaning {
  FLAG = 'flag',
  BORDERLINE = 'borderline',
  NEUTRAL = 'neutral',
  CLEAR = 'clear',
}

export type ConditionForKit = {
  display_title: string;
  name: string;
  type: string;

  kit_id: string;
  evaluation: string;
  evaluation_meaning: ConditionEvaluationMeaning;
  evaluation_text: string;
  /* OPTIONAL */
  age_low?: number;
  age_high?: number;
  about?: string;
  checkpoints?: string;
  created_at?: string;
  evidence_rating?: string;
  id?: number;
  empty_state?: string;
  decreased_risk?: string;
  display_order?: number;
  increased_risk?: string;
  other_factors?: string;
  faq?: string;
  references?: string;
  updated_at?: string;

  guides?: Guide[];
};

export type NewCondition = {
  condition_id: number;
  condition: string;
  condition_display_name: string;
  evaluation_text: string;
  about: string;
  faq: string;
  references: string;
  id: number;
  kit_id: string;
  negative_score: number;
  positive_score: number;
  type: ConditionType;
};

export type ConditionMetric = {
  id: number;
  metric_id: number;
  condition_id: number;
  condition: string;
  condition_display_name: string;
  name: string;
  display_title: string;
  evaluation_color: string;
  user_value: number;
  health_metrics_barscale_percentage: number;
  data_type: string;
};

export type ConditionActionPlan = {
  action_plan_recommendations_id: number;
  criteria_level: string;
  section: string;
  tags: string;
};
